<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.idList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label style="width:">创建时间:</label>
            <timeStampDatePicker  placeholder="请选择"   class="item" v-model.trim='query.createTime' ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label style="width:">门店管理员:</label>
            <lk-input :maxlength='100' placeholder='请输入'  class="item" clearable v-model.trim='query.managerName'></lk-input>
          </div>
          <div class="queryItem">
            <label style="width:">门店级别:</label>
            <lk-select class="item" clearable v-model.trim='query.level'>
              <lk-option v-for="(item,index) in levels" :key="item" :value='index+1'>{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label style="width:">门店类型:</label>
            <lk-select class="item" clearable v-model.trim='query.type'>
              <lk-option v-for="(item,index) in storeTypes" :key="item" :value='index+1'>{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label style="width:">状态:</label>
            <lk-select class="item" clearable v-model.trim='query.status'>
              <lk-option v-for="(item) in statusList" :key="item" :value='item.status'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' icon='md-add' @click="$router.push({ name:'storeAdd' });" v-if="handlePermission('storeAdd')">新建门店</lk-button>
          <DownloadButton @on-click="handleExport" v-if="handlePermission('storeExport')"></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import system from '@/services/system';
import utils from '@/libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '@/components/download/DownloadButton';

export default {
  name: 'StoreList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
  },
  data() {
    return {
      storeList: [],
      storeTypes: ['直营', '收购', '加盟'],
      statusList: [{ status: 1, name: '启用' }, { status: 2, name: '禁用' }],
      query: {
        managerName: '',
        createTime: null,
        level: '',
        type: '',
      },
      columns: [
        { title: '门店ID', key: 'code', minWidth: 116 },
        { title: '门店名称', key: 'name', minWidth: 116 },
        { title: '门店级别', key: 'level', minWidth: 116 },
        { title: '门店类型', key: 'type', minWidth: 116 },
        { title: '门店管理员', key: 'managers', minWidth: 116 },
        { title: '企业负责人', key: 'leaderName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        {
          title: '状态',
          key: 'status',
          minWidth: 116,
          render: (h, params) => (
            this.handlePermission('storeEnableDisable') ? h('lk-switch', {
              props: {
                size: 'large',
                value: params.row.status === 1,
                loading: params.row.loading,
              },
              on: {
                'on-change': (flag) => { // 接口有问题后续调
                  params.row.loading = true;
                  const toggleFunction = flag ? system.storeEnable : system.storeDisable;
                  const Message = flag ? '该门店已启用' : '该门店已禁用';
                  const data = {
                    sysStore: {
                      id: params.row.id,
                    },
                  };
                  toggleFunction(data).then((res) => {
                    if (res.data.status === 200) {
                      this.$Message.success(Message);
                      params.row.loading = false;
                    } else {
                      params.row.loading = false;
                      this.$Message.error(res.data.error);
                      this.getData();
                    }
                  }).catch((err) => {
                    params.row.loading = false;
                    this.getData();
                    utils.handleError(err);
                  });
                },
              },
            }, [
              h('span', {
                props: {
                },
                slot: 'open',

              }, '启用'),
              h('span', {
                props: {
                },
                slot: 'close',

              }, '禁用'),
            ]) : h('span', params.row.status === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('storeInfo') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'storeInfo', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('storeEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'storeEdit', params: { id: params.row.id } });
                },
              },
            }, '修改') : null,
          ]),
        },
      ],
      tableData: [],
      levels: ['一级', '二级', '三级'],
    };
  },
  methods: {
    clear() {
      this.query = {
        name: '', // 门店名称
        leaderName: '',
        createTime: null,
        level: '',
        type: '',
        idList: [],
      };
    },
    // handleSearch() {
    //   this.page = 1;
    //   this.getData();
    // },
    handleExport() {
      const exportFunc = system.storeInfoListExport;
      this.params.page = this.page;
      this.params.size = this.size;
      this.params.queryCondition = utils.getQueryCondition('.queryContainer');
      exportFunc(utils.deletePageAndSize(this.params))
        .then((res) => {
          if (res.data.status !== 200) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      this.$route.params.create ? this.params.create = true : this.params.create = '';

      // this.params.createTime = utils.exchangeDate(this.params.createTime);
      system.storeList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = Object.assign({}, item.sysStore);
            result.createTime = utils.formatTime(result.createTime);
            result.leaderName = result.leaderName || '-';
            result.level = this.levels[result.level - 1] || '-';
            result.loading = false;
            result.type = this.storeTypes[result.type - 1] || '-';
            result.managers = [];
            item.managerList.forEach((el) => {
              result.managers.push(el.name);
            });
            result.managers = result.managers.join(',') || '-';
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page, isSearch) {
    //   this.page = page;
    //   this.getData();
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.getData();
    // },
    addNew() {
      this.$router.push({ name: 'storeAdd' });
    },
  },
  mounted() {
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .queryContainer{//样式写进公共类中
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
  .btns{
    display: flex;
    // justify-content: space-between;
    margin-bottom: 12px;
    // padding-top: 16px;
    div:last-child>*{
      margin-left: 16px
    }
    >*{
      margin-right: 16px
    }
  }
</style>
